export default "__VITE_ASSET__NsCLDkkh__"